export default __webpack_public_path__ + "static/media/relatedstories-image.867a8dd5.png";